import React from "react";
import { Toast } from "antd-mobile";
import "./toast.css";
import { CheckOutline, CloseOutline } from "./icons";

function show(p) {
  // 自定义处理 icon 样式
  if (p === null || p === void 0 ? void 0 : p.icon) {
    switch (p.icon) {
      case "success":
        return Toast.show(Object.assign(Object.assign({}, p), {
          icon: React.createElement(CheckOutline, null)
        }));

      case "fail":
        return Toast.show(Object.assign(Object.assign({}, p), {
          icon: React.createElement(CloseOutline, null)
        }));
    }
  }

  return Toast.show(p);
} // 以下几种方法，只是为了兼容以前的代码，不建议后续继续使用，以antd最新大版本为准


function info(p) {
  return show(p);
}

function success(p) {
  return show(Object.assign(Object.assign({}, p), {
    icon: "success"
  }));
}

function fail(p) {
  return show(Object.assign(Object.assign({}, p), {
    icon: "fail"
  }));
}

export default Object.assign(Object.assign({}, Toast), {
  // 重写 antd-mobile 的show方法，以便于可以自定义部分样式
  show,
  // 以下只是为了兼容以前的业务代码，不建议直接使用
  info,
  success,
  fail
});